import { useEffect } from "react";
import { useParams } from "react-router-dom";
import MyChallenge from "../challenge/MyChallenge";
import EmptyChallenge from "../challenge/EmptyChallenge";
import styled from "styled-components";
import { TheirChallenge } from "../challenge/TheirChallenge";
import { useOwnCid } from "../challenge/useOwnCid";


function setThemeColor(color) {
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor["name"] = 'theme-color';
    document.head.appendChild(themeColor);
  }
  themeColor.setAttribute('content', color);
}

export default function Challenge() {
  const { cid } = useParams();
  const { ownCid } = useOwnCid();

  useEffect(() => {
    console.log("challenge cid:", cid, " ownCid:", ownCid);
  }, [cid, ownCid]);

  useEffect(() => {
    const rootElement = document.getElementById('root');    
    rootElement.classList.add("challenge-green");
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDark) {
      setThemeColor('hsl(120, 40%, 18%)');
    } else {
      setThemeColor('hsl(120, 40%, 18%)');
    }
    return () => {
      rootElement.classList.remove("challenge-green");
      rootElement.classList.remove("challenge-bronze");
      rootElement.classList.remove("challenge-silver");
      rootElement.classList.remove("challenge-gold");
      if (isDark) {
        setThemeColor('#002266');
      } else {
        setThemeColor('#003399');
      }
      }
  }, []);

  
  return (
    <ChallengePage className="ChallengePage">
      <ChallengeContent className="ChallengeContent">
        {(!ownCid && !cid)
          ? <EmptyChallenge /> 
          : (cid === ownCid || (ownCid && !cid)) 
          ? <MyChallenge />
          : <TheirChallenge cid={cid} ownCid={ownCid} />
        }
      </ChallengeContent>
    </ChallengePage>
  )
}

const ChallengePage = styled.div`
  display: block;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 30px 40px;
  background: var(--bg-color);

  @media (max-width: 950px) {
    padding: 10px;
  }
`


const ChallengeContent = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 100px;
`
